import { useState } from 'react';
import axios from 'axios';

const usePostalCodeSearch = (setValue) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchAddress = async (postalCode) => {
    if (postalCode.length !== 7) return;

    setLoading(true);
    try {
      const response = await axios.get(`https://api.zipaddress.net/?zipcode=${postalCode}`);

      if (response.data && response.data.data) {
        const { pref, city, town } = response.data.data;
        const fullAddress = `${city} ${town}`;

        // バリデーションを走らせる
        setValue('state', pref, { shouldValidate: true });
        setValue('address_line', fullAddress, { shouldValidate: true });
      } else {
        setError('住所が見つかりませんでした。');
        setValue('state', '', { shouldValidate: true });
        setValue('address_line', '', { shouldValidate: true });
      }
    } catch (err) {
      setError('住所取得に失敗しました。');
      console.error('住所取得エラー:', err);
      setValue('state', '', { shouldValidate: true });
      setValue('address_line', '', { shouldValidate: true });
    } finally {
      setLoading(false);
    }
  };

  const handlePostalCodeChange = (e) => {
    const postalCode = e.target.value.replace(/\D/g, ''); // 数字のみ
    setValue('postal_code', postalCode, { shouldValidate: true });

    if (postalCode.length === 7) {
      fetchAddress(postalCode);
    } else {
      setValue('state', '', { shouldValidate: true });
      setValue('address_line', '', { shouldValidate: true });
    }
  };

  return {
    loading,
    error,
    handlePostalCodeChange,
  };
};

export default usePostalCodeSearch;
